import { render, staticRenderFns } from "./Items.list.vue?vue&type=template&id=ad9c5b92&"
import script from "./Items.list.vue?vue&type=script&lang=js&"
export * from "./Items.list.vue?vue&type=script&lang=js&"
import style0 from "./Items.list.vue?vue&type=style&index=0&id=ad9c5b92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports